import { render } from "./RecruitPage.vue?vue&type=template&id=08ca5506"
import script from "./RecruitPage.vue?vue&type=script&lang=js"
export * from "./RecruitPage.vue?vue&type=script&lang=js"

import "./RecruitPage.vue?vue&type=style&index=0&id=08ca5506&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__